import { SinglePostScreen } from '~/components/domain/posts/SinglePostScreen';
import { useLocalSearchParams } from 'expo-router';

export default function PostPage() {
  const { id } = useLocalSearchParams<{ id: string }>();

  if (!id) {
    return null;
  }

  const postId = parseInt(id, 10);

  if (isNaN(postId)) {
    return null;
  }

  return <SinglePostScreen postId={postId} />;
}
